import { api } from "@/services/api";
import { DeleteResponse, PaginatedResponse } from "@/types";
import {
  AddKeyword,
  Keyword,
  KeywordFilters,
  UpdateKeyword,
} from "@/types/keyword";

export class KeywordRepository {
  async findAll(filters: KeywordFilters): Promise<PaginatedResponse<Keyword>> {
    const response = await api.get(`/v1/keywords`, { params: filters });

    return response.data;
  }

  async add(data: AddKeyword): Promise<Keyword> {
    const response = await api.post("/v1/keywords", data);

    return response.data;
  }

  async update(data: UpdateKeyword): Promise<Keyword> {
    const { id, ...payload } = data;
    const response = await api.patch(`/v1/keywords/${id}`, payload);

    return response.data;
  }

  async delete(id: string): Promise<DeleteResponse> {
    const response = await api.delete(`/v1/keywords/${id}`);

    return response.data;
  }
}
